import { gql } from 'graphql-request';

import { gqlClient } from 'graphql/gqlClient';
import { EditableEvent } from 'types/event.types';

type RestoreCancelledEventResponse = {
  restoreCancelledEvent: {
    ok: boolean;
    event: EditableEvent;
  };
};

const RESTORE_CANCELLED_EVENT_MUTATION = gql`
  mutation RestoreCancelledEvent($eventId: Int!) {
    restoreCancelledEvent(eventId: $eventId) {
      ok
      event {
        id
      }
    }
  }
`;

const cancelledEventApi = {
  restore: async (
    eventId: number
  ): Promise<RestoreCancelledEventResponse['restoreCancelledEvent']> => {
    return gqlClient
      .request<RestoreCancelledEventResponse>(RESTORE_CANCELLED_EVENT_MUTATION, { eventId })
      .then((response) => response.restoreCancelledEvent);
  }
};

export { cancelledEventApi };
